import moment from 'moment'
import formatImages from './formatImages'

export default function formatItinerary(itinerary, startDate) {
  if (!itinerary || !itinerary.length) return []

  const embarkDay = itinerary.find(day => day.activity === 'EMBARK')
  let embarkDate
  if (embarkDay) {
    embarkDate = embarkDay.day
  }
  return itinerary.map(day => {
    if (day.activity !== 'Cruisetour') {
      return formatDay(day, startDate)
    } else {
      const flag =
        Number(day.day) <= Number(embarkDate)
          ? 'Pre-Cruisetour'
          : 'Post-Cruisetour'

      return {
        ...formatDay(day, startDate),
        flag
      }
    }
  })
}

function formatDay(day, startDate) {
  const displayDate = moment(startDate, 'YYYY-MM-DD')
    .add(Number(day.day) - 1, 'days')
    .format('YYYY-MM-DD')
  return {
    ...day,
    displayDate,
    highlight: {
      ...day.highlight,
      image:
        day.highlight && day.highlight.image
          ? formatImages(day.highlight.image, [
              'details-hero',
              'itineraries-and-destinations'
            ])
          : {}
    }
  }
}
